import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type Upload = {
  file: File;
  file_name: string;
};

export type Download = {
  file_name: string;
};

const $http = new APIManager();

const Api = {
  /**
   * [POST] Upload File
   * --
   */
  uploadFile: async (body: Upload, form: boolean = true) => {
    try {
      const res = await $http.multipart(APIConstant.UPLOAD_FILE, body, form);

      return res;
    } catch (e) {
      throw e;
    }
  },
  /**
   * [POST] Upload File
   * --
   */
  uploadFileMulti: async (body: Upload[]) => {
    try {
      const res = await $http.multipart(APIConstant.UPLOAD_MULTI_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Download File
   * --
   */
  downloadFile: async (body: Download) => {
    try {
      const res = await $http.post(APIConstant.DOWNLOAD_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Upload File
   * --
   */
  multiUploadFile: async (body: Upload[], form: boolean = true) => {
    try {
      const res = await $http.multipart(
        APIConstant.MULTI_UPLOAD_FILE,
        body,
        form
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
